import Cookies from 'js-cookie';
import { SupportedLanguage } from '../types/language';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '../constants/languages';

const COOKIE_NAME = 'i18next';
const COOKIE_EXPIRY = 365; // days

export const saveLanguagePreference = (language: SupportedLanguage): void => {
  if (isValidLanguage(language)) {
    Cookies.set(COOKIE_NAME, language, { expires: COOKIE_EXPIRY });
    updateDocumentLanguage(language);
  }
};

export const getStoredLanguage = (): SupportedLanguage | null => {
  const stored = Cookies.get(COOKIE_NAME);
  return isValidLanguage(stored) ? stored as SupportedLanguage : null;
};

export const detectUserLanguage = (): SupportedLanguage => {
  const stored = getStoredLanguage();
  if (stored) return stored;

  const browserLang = getBrowserLanguage();
  return isValidLanguage(browserLang) ? browserLang : DEFAULT_LANGUAGE;
};

export const isValidLanguage = (code: string | undefined): code is SupportedLanguage => {
  return Boolean(code && SUPPORTED_LANGUAGES.includes(code as SupportedLanguage));
};

export const updateDocumentLanguage = (language: SupportedLanguage): void => {
  document.documentElement.lang = language;
};

const getBrowserLanguage = (): string => {
  return navigator.language.split('-')[0];
};